import gql from 'graphql-tag';

export const FORM_COMPLETION_QUERY = gql`
  query formCompletion($formId: Int!) {
    formCompletion(formId: $formId) {
      id
      answers {
        id
        data
        formElementId
      }
    }
  }
`;

export interface FormCompletionQueryArguments {
  formId: number;
}

export interface FormCompletionQueryResponse {
  formCompletion: {
    id: string;
    percentageComplete: number;
    answers: {
      id: string;
      data: string;
      formElementId: number;
    }[];
    __typename: 'FormCompletion';
  } | null;
}
